import styled, { css } from 'styled-components';
import { cardBase } from '@/styles/mixins';
import { CardProps } from '@/Models';

export const Card = styled.div<CardProps>`
  ${cardBase}
  overflow: hidden;
  width: 100%;
  
  /* Padding */
  ${({ $padding = 'md', theme }) => {
    switch ($padding) {
      case 'none':
        return '';
      case 'sm':
        return css`
          padding: ${theme.spacing.md};
        `;
      case 'lg':
        return css`
          padding: ${theme.spacing.xl};
        `;
      case 'xl':
        return css`
          padding: ${theme.spacing['2xl']};
        `;
      default:
        return css`
          padding: ${theme.spacing.lg};
        `;
    }
  }}
  
  /* Elevation */
  ${({ $elevation = 'low', theme }) => {
    switch ($elevation) {
      case 'none':
        return '';
      case 'medium':
        return css`
          box-shadow: ${theme.shadows.md};
        `;
      case 'high':
        return css`
          box-shadow: ${theme.shadows.lg};
        `;
      default:
        return css`
          box-shadow: ${theme.shadows.sm};
        `;
    }
  }}
  
  /* Border */
  ${({ $border = true }) =>
    $border &&
    css`
      border: 1px solid ${({ theme }) => theme.colors.grayLight};
    `}
`;

export const CardHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  padding-bottom: ${({ theme }) => theme.spacing.md};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayLighter};
`;

export const CardTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.fontSize.xl};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;
`;

export const CardBody = styled.div`
  line-height: ${({ theme }) => theme.typography.lineHeight.normal};
`;